import { InjectionToken } from '@angular/core';
import { CalculationId } from '@marmon/shared/types/analysis';
import { BehaviorSubject } from 'rxjs';

export const CALCULATION_ID = new InjectionToken<
	BehaviorSubject<CalculationId | null>
>('CalculationIdToken');
